<template>
	<div class="editor-controls">
		<div class="controls">
			<ui-button
				svg-icon
				tooltip="Mark start"
				@click="$emit('markIn')"
			>
				<path d="M 12 0 l 0 8 -4 4 4 4 0 8"/>
			</ui-button>
			<ui-button
				svg-icon
				tooltip="Go to start"
				@click="$emit('goToIn')"
			>
				<path d="M 6 0 l 0 8 -4 4 4 4 0 8 M 7 12 l 12 10 0 -20 -12 10"/>
			</ui-button>
			<ui-button
				icon="fal fa-step-backward"
				tooltip="Step backward"
				@click="$emit('stepBackward')"
			/>
			<ui-button
				v-show="!isPlaying"
				icon="fal fa-play"
				tooltip="Play"
				@click="$emit('play')"
			/>
			<ui-button
				v-show="isPlaying"
				icon="fal fa-pause"
				tooltip="Pause"
				@click="$emit('pause')"
			/>
			<ui-button
				icon="fal fa-step-forward"
				tooltip="Step forward"
				@click="$emit('stepForward')"
			/>
			<ui-button
				svg-icon
				tooltip="Go to end"
				@click="$emit('goToOut')"
			>
				<path d="M 17 0 l 0 8 4 4 -4 4 0 8 M 16 12 l -12 10 0 -20 12 10"/>
			</ui-button>
			<ui-button
				svg-icon
				tooltip="Mark end"
				@click="$emit('markOut')"
			>
				<path d="M 12 0 l 0 8 4 4 -4 4 0 8"/>
			</ui-button>
		</div>
	</div>
</template>
<script>
import UiButton from "lib/components/ui/Button";

export default {
	name: "MediaEditorControls",
	components: {
		UiButton
	},
	props: {
		isPlaying: {
			type: Boolean,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.editor-controls {
	display: flex;
	justify-content: center;
	button {
		&:first-child {
			margin-left: 0px;
		}
		&:last-child {
			margin-right: 0px;
		}
		path {
			fill: none;
			stroke-width: 1.4;
			stroke-linecap: round;
			stroke-linejoin: round;
			stroke: var(--ui-theme-icon);
		}
	}
}
</style>
